import React from 'react';

const Footer = () => {
  // Footer intentionally removed (white-label)
  return null;
};

export default React.memo(Footer);
